import { render, staticRenderFns } from "./HtmlRenderer.vue?vue&type=template&id=5cb82284&scoped=true&"
import script from "./HtmlRenderer.vue?vue&type=script&lang=js&"
export * from "./HtmlRenderer.vue?vue&type=script&lang=js&"
import style0 from "./HtmlRenderer.vue?vue&type=style&index=0&id=5cb82284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb82284",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cb82284')) {
      api.createRecord('5cb82284', component.options)
    } else {
      api.reload('5cb82284', component.options)
    }
    module.hot.accept("./HtmlRenderer.vue?vue&type=template&id=5cb82284&scoped=true&", function () {
      api.rerender('5cb82284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HtmlRenderer.vue"
export default component.exports